// AboutUsPage.tsx
import React, { useEffect } from 'react';

const AboutUsPage: React.FC = () => {
  // Scroll reveal effect - exactly as HTML
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal');
    
    const checkReveal = () => {
      reveals.forEach((el) => {
        if (el.getBoundingClientRect().top < window.innerHeight - 120) {
          el.classList.add('active');
        }
      });
    };

    window.addEventListener('scroll', checkReveal);
    window.addEventListener('load', checkReveal);
    
    return () => {
      window.removeEventListener('scroll', checkReveal);
      window.removeEventListener('load', checkReveal);
    };
  }, []);

  return (
    <>
      {/* Tailwind CSS CDN */}
      <link 
        href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" 
        rel="stylesheet"
      />
      
      {/* Font Awesome 6 CDN */}
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
      />
      
      <style>{`
        /* Custom animations that Tailwind doesn't provide */
        @keyframes floatImage {
          0% { transform: translateY(0); }
          50% { 
            transform: translateY(-12px); 
            box-shadow: 0 20px 30px -8px rgba(20, 184, 166, 0.4);
          }
          100% { transform: translateY(0); }
        }
        
        @keyframes slideInRight {
          0% {
            opacity: 0;
            transform: translateX(40px);
          }
          100% {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        .animate-float {
          animation: floatImage 5s ease-in-out infinite;
        }
        
        .animate-slideInRight {
          animation: slideInRight 0.9s ease-out;
        }
        
        .reveal {
          opacity: 0;
          transform: translateY(40px);
          transition: all 0.9s cubic-bezier(0.2, 0.9, 0.3, 1);
        }
        
        .reveal.active {
          opacity: 1;
          transform: translateY(0);
        }
        
        /* Custom underline for section header */
        .section-header-underline {
          position: relative;
          display: inline-block;
        }
        
        .section-header-underline::after {
          content: "";
          position: absolute;
          bottom: -15px;
          left: 50%;
          transform: translateX(-50%);
          width: 70px;
          height: 3px;
          background: #14b8a6;
        }
        
        /* Signature style */
        .signature {
          color: #6b7280;
          font-style: italic;
        }

        /* Image container style */
        .image-container {
          height: auto;
          max-height: 500px;
        }
      `}</style>

      {/* Background wrapper - solid color for About Us only */}
      <div className="bg-[#F2F4D0] w-full min-h-screen overflow-x-hidden font-sans">
        {/* About Section - Exact match to HTML */}
        <section id="about" className="max-w-[1300px] mx-auto px-8 py-20 reveal">
          {/* Section Header */}
          <div className="text-center mb-14">
            <h2 className="text-3xl md:text-[2.6rem] font-bold text-gray-900 section-header-underline">
              About Us
            </h2>
          </div>
          
          {/* About Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            {/* Image with floating animation - FIXED */}
            <div className="rounded-[32px] overflow-hidden border-2 border-teal-500/20 image-container animate-float">
              <img 
                src="image.png" 
                alt="SAJ ENTERPRISES team" 
                className="w-full h-full object-contain"
              />
            </div>
            
            {/* Content with slide-in animation */}
            <div className="animate-slideInRight">
              <h2 className="text-3xl md:text-[2.2rem] text-amber-500 font-bold mb-4">
                Trusted since 2021
              </h2>
              
              <p className="text-gray-700 mb-4 leading-relaxed">
                SAJ ENTERPRISES is a Pune-based industrial partner offering
                comprehensive sales, service, and spares. We serve factories,
                warehouses, and logistics hubs with reliable material handling
                equipment, batteries, chargers, and dock solutions.
              </p>
              
              <p className="text-gray-700 mb-4 leading-relaxed">
                Our vision is to minimize downtime through quality spares and
                expert on-site service. We believe in long-term relationships
                built on trust, transparency, and industrial expertise.
              </p>
              
              <p className="signature text-gray-500 italic mt-6">
                — Sales, Service & Spares, under one roof.
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AboutUsPage;